import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getInvoiceGroupsList } from '@/utils/invoices';

export const procedureInvoicesRoute: RouteConfig = {
  path: 'reports/invoices',
  name: 'procedureInvoices',
  component: () =>
    import(/* webpackChunkName: "InvoicesRepository" */ '@/views/mainRoute/procedure/details/Invoices.vue'),
  beforeEnter: (to, from, next) => {
    getInvoiceGroupsList(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.REPORT_CANNOT_GET }));
  }
};
